var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { grow: "" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.chartData.title) + " ")]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content", "no-padding": "" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _vm._l(_vm.saldos, function (saldo) {
                return _c(
                  "w-col",
                  {
                    key: saldo.type.ID,
                    attrs: { xs: "6", md: _vm.colWidth, "no-margin": "" },
                  },
                  [
                    _c("div", { staticClass: "tiny-total" }, [
                      _vm._v(
                        " € " + _vm._s(_vm.printHumanFloat(saldo.saldo)) + " "
                      ),
                      _c("span", { staticClass: "bank-name" }, [
                        _vm._v(" " + _vm._s(saldo.type.Name) + " "),
                      ]),
                    ]),
                  ]
                )
              }),
              _vm.chartData.addTotal
                ? _c(
                    "w-col",
                    { attrs: { xs: "6", md: _vm.colWidth, "no-margin": "" } },
                    [
                      _c("div", { staticClass: "tiny-total" }, [
                        _vm._v(
                          " € " + _vm._s(_vm.printHumanFloat(_vm.total)) + " "
                        ),
                        _c("span", { staticClass: "bank-name" }, [
                          _vm._v(" " + _vm._s(_vm.$ct("total")) + " "),
                        ]),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }